import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "pages/Login/store/store";
import adminReducer from "pages/admin/store";
import teacherReducer from "pages/teacher/store";
import parentReducer from "pages/parent/store";
import directorReducer from "pages/director/store";
import reportsReducer from "pages/reports/store";

const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
  teacher: teacherReducer,
  parent: parentReducer,
  director: directorReducer,
  reports: reportsReducer,
});

export default rootReducer;
